module.exports = __webpack_public_path__ + "static/media/Cruise.e4876826.jpg";